import {Injectable} from '@angular/core';
import {ComponentCatalogComponent, getComponentCatalogComponents} from '../component-catalog.decorator';
import {MarkedService} from './marked.service';

export interface ComponentCatalogGroup {
  name: string;
  components: ComponentCatalogComponent[];
  id: string;
}

@Injectable({
  providedIn: 'root',
})
export class ComponentService {
  private readonly components: { [key: string]: ComponentCatalogComponent } = {};
  private readonly groups: { [key: string]: ComponentCatalogGroup } = {};

  constructor(markedService: MarkedService) {
    getComponentCatalogComponents().forEach(component => {
      const groupId = markedService.slug(component.group);
      const componentId = component.id = markedService.slug(component.name);
      this.components[`${groupId}/${componentId}`] = component;

      const components = this.groups[groupId] = this.groups[groupId] || { name: component.group, components: [], id: groupId };
      components.components.push(component);
    });
  }

  getGroups(): Map<string, ComponentCatalogGroup> {
    const groups = new Map<string, ComponentCatalogGroup>();
    Object.keys(this.groups).forEach(key => {
      const group = this.groups[key];
      groups.set(key, { ...group, components: [...group.components] });
    });
    return groups;
  }

  getComponent(groupId: string, componentId: string): ComponentCatalogComponent | undefined {
    return this.components[`${groupId}/${componentId}`];
  }
}
